
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcPoiCardHeader as ObcPoiCardHeaderElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-card-header/poi-card-header.js';
 
 
 

 
 export const ObcPoiCardHeader = createComponent({
   react: React,
   tagName: 'obc-poi-card-header',
   elementClass: ObcPoiCardHeaderElement,
   events: {
     
     onCloseClick: 'close-click' as EventName<CustomEvent<void>>,
   }
  });
 
 